import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
// 先上配置主题样式
import 'element-ui/lib/theme-chalk/index.css'
// 本地主题样式
import '@/assets/css/elementui.scss'
Vue.use(ElementUI);

import 'babel-polyfill'

// 挂载全局
import httpRequest from '@/utils/httpRequest'
Vue.prototype.$http = httpRequest

import URLencodeMixin from "@/mixins/URLencode";
Vue.mixin(URLencodeMixin);

import { refreshLocalFEVersion } from '@/api/checkVersion'

// 打开网页时同步一次版本号,该函数一定要在router.beforeEach前执行
refreshLocalFEVersion()

// permission control
import '@/permission'

// 重置css
import '@/assets/css/reset.scss'
// iconfont
import "@/assets/cgptFont/iconfont.css";

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js